if(localStorage.last_visit_time != undefined){
    if((Date.now() - localStorage.last_visit_time*1) > 2*24*60*60*1000){
      localStorage.last_visit_time = Date.now();
      localStorage.open_video_modal = 'true';
    }
  }else{
    localStorage.last_visit_time = Date.now();
    localStorage.open_video_modal = 'true';
  }  
document.addEventListener('DOMContentLoaded', function() {
  if(localStorage.open_video_modal == 'true'){
    document.querySelector('.video-popup-wraper').style.display = 'block';
  }
  document.querySelector('.ppp-video-wraper .popup__close')?.addEventListener('click',function() {
    document.querySelector('.video-popup-wraper').style.display = 'none';
    document.querySelector('.ppp-video-wraper iframe').remove();
    localStorage.open_video_modal = '';
  })
})